import {
	init
} from '@sentry/browser';

document.addEventListener("DOMContentLoaded", function () {
	init({
		dsn: "https://a5605dd69ccb4a44dfced9b36bebc49d@sentry.nperf.com/8",
		integrations: function (integrations) {
			const packagesDisabled = [
				'LinkedErrors',
				'BrowserTracing',
				'Replay',
				'ContextLines',
				'ExtraErrorData',
				'ReportingObserver',
				''
			]
			return integrations.filter(function (integration) {
				return !packagesDisabled.includes(integration.name);
			});
		},
		maxBreadcrumbs: 50,
		environment: process.env.NODE_ENV,
		release: 'website-nperf-js@' + process.env.RELEASE_VERSION,
		autoSessionTracking: false,
		beforeSend(event) {
			try {
				if (event.exception.values[0].stacktrace.frames[0].filename === `<anonymous>`) {
					return null;
				}
			} catch (e) {
				return null;
			}
			return event;
		}
	});
})